import { ApModal, colors } from '@alixpartners/ui-components';
import styled, { css } from 'styled-components';
import { ColumnNamesValues, COLUMN_NAMES, DESC } from './ExpenseDetailsModal';

export const InputModalContent = styled.div`
  box-sizing: border-box;
  & * {
    box-sizing: border-box;
  }
`;

export const Table = styled.div`
  display: flex;
  flex-direction: column;
`;

export const SubTitle = styled.div`
  font-size: 16px;
  letter-spacing: 0.3px;
  line-height: 24px;
  font-weight: normal;
`;

export const ServiceListContainer = styled.div`
  font-size: 16px;
  letter-spacing: 0.3px;
  line-height: 31px;
  text-align: left;

  ul {
    margin: 0;
    padding: 10px 16px 16px 26px;
  }
`;

export const StyledApModal = styled(ApModal)`
  .ap-modal-content {
    margin: 0 114px;
    max-width: 942px;
    max-height: 60vh;
  }

  .ap-modal-header,
  .ap-modal-footer {
    padding: 16px 32px;
  }

  .ap-modal-footer {
    background-color: ${colors.grey1};
  }

  .ap-modal-body {
    overflow-y: initial;
    padding: 0;
  }

  .ap-button-icon {
    align-self: flex-start;
  }
`;

export const InfoLink = styled.span`
  outline: none;
  color: ${colors.green500};
  font-size: 16px;
  font-weight: bold;
  letter-spacing: 0.3px;
  line-height: 24px;
  cursor: pointer;
  text-decoration: none;
  font-weight: normal;

  &:hover {
    text-decoration: underline;
    color: ${colors.green500};
  }
`;

export const HeaderWrapper = styled.div`
  line-height: 35px;
`;

export const InputModalFooter = styled.div`
  justify-content: space-between;
  display: flex;
  flex-direction: row-reverse;

  a {
    text-transform: uppercase;
    font-size: 13px;
    height: 36px;
    padding: 2px 8px;
  }
`;

const colSizesMap: {
  [key: string]: number | string;
} = {
  service: 5,
  resource: 'auto',
  'last-month': 4,
  'this-month': 4,
  delta: 2,
};

export const TableHeaderBlock = styled.div<{
  sortingOrder: false | string;
  headerName: ColumnNamesValues;
}>`
  display: flex;
  width: 100%;
  padding: 0;
  align-items: center;
  user-select: none;

  div {
    text-transform: uppercase;
    color: #b6b6b6;
    font-size: 11px;
    line-height: 13px;
    cursor: pointer;
  }

  svg {
    transition: none;
  }

  ${({ headerName }) => css`
    flex: ${colSizesMap[headerName]};
  `}
  ${({ sortingOrder }) =>
    sortingOrder === DESC
      ? css`
          svg {
            transform: rotate(270deg);
          }
        `
      : ''}
`;

export const TableData = styled.div`
  height: 33vh;
  overflow: scroll;
  padding: 0 32px;
`;

export const TableHeaderRow = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;

  padding: 8px 32px;

  div {
    text-transform: uppercase;
    color: #b6b6b6;
    font-size: 11px;
    line-height: 13px;
    cursor: pointer;
  }
`;

export const TableDataRow = styled.div`
  padding: 12px 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  border-bottom: 1px solid ${colors.grey300};
`;

export const TableDataBlock = styled.div<{
  headerName: ColumnNamesValues;
}>`
  ${({ headerName }) =>
    headerName === COLUMN_NAMES.service
      ? css`
          text-transform: capitalize;

          div {
            color: #737373;
            font-size: 13px;
            letter-spacing: 0.8px;
            line-height: 19px;
            margin-top: 8px;

            display: block;
            max-width: 200px;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }
        `
      : ''}

  ${({ headerName }) => css`
    flex: ${colSizesMap[headerName]};
  `}
`;

export const TotalDataRow = styled(TableDataRow)`
  border-bottom: none;
  padding: 10px 32px;
  font-weight: bold;
`;
